import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { calculateSeconds } from '@alfa-bank/site-helpers-transform/time/calculate-seconds';
import { secondsToTime } from '@alfa-bank/site-helpers-transform/time/seconds-to-time';

import { Timer as Component } from './timer';
import type { IDeps, TTimer } from './models';

export const Timer = createWidget<IDeps, TTimer>({
    calculateSeconds,
    secondsToTime,
})(Component);
